export default class OtpData {
    code: string;
    key: string;

    constructor(code: string, key: string) {
        this.code = code;
        this.key = key;
    }
}
